"use client";

import React, { useEffect, useRef, useState } from "react";
import { isHoverCapable } from "@/app/lib/utils";
import styles from "./customCursor.module.scss";

export function CustomCursor() {
  const cursorRef = useRef(null);
  const rafRef = useRef(null);
  const [enabled, setEnabled] = useState(false);
  const [hoveredStates, setHoveredStates] = useState([]);

  useEffect(() => {
    if (isHoverCapable()) setEnabled(true);
  }, []);

  useEffect(() => {
    if (!enabled) return;

    const cursorEl = cursorRef.current;
    if (!cursorEl) return;

    const CLASS_MAP = {
      link: styles.link,
      left: styles.left,
      right: styles.right,
    };

    // This function will be called whenever the mouse moves
    const moveHandler = (e) => {
      // Find the closest element with a class that we care about
      const linkEl = e.target.closest("a");
      const scrollEl = e.target.closest(".cursor-scroll");
      const currentStates = [];
      let newTranslateX = e.clientX;
      let newTranslateY = e.clientY;

      if (scrollEl) {
        if (scrollEl.classList.contains("cursor-scroll-left")) {
          currentStates.push("left");
        } else if (scrollEl.classList.contains("cursor-scroll-right")) {
          currentStates.push("right");
        }
      }

      if (linkEl) {
        currentStates.push("link");
      }

      // Update the state based on the element being hovered
      setHoveredStates(currentStates);

      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }

      rafRef.current = requestAnimationFrame(() => {
        cursorEl.style.transform = `translate(${newTranslateX - 32}px, ${newTranslateY - 32}px)`;
      });
    };

    document.addEventListener("mousemove", moveHandler);

    return () => {
      document.removeEventListener("mousemove", moveHandler);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [enabled]);

  useEffect(() => {
    const cursorEl = cursorRef.current;
    if (!cursorEl) return;

    const CLASS_MAP = {
      link: styles.link,
      left: styles.left,
      right: styles.right,
    };

    // Reset all classes
    Object.values(CLASS_MAP).forEach(cls => cursorEl.classList.remove(cls));

    // Apply new classes from the state
    hoveredStates.forEach(state => {
      const cssClass = CLASS_MAP[state];
      if (cssClass) {
        cursorEl.classList.add(cssClass);
      }
    });
  }, [hoveredStates]);

  if (!enabled) return null;

  return (
    <div ref={cursorRef} className={styles.customCursor}>
      <svg viewBox="0 0 53.9 53.9">
        <circle cx="26.9" cy="26.9" r="24.7" fill="#eb008c"/>
        <polygon fill="#fff" points="41.1 26.8 39.5 25.1 39.5 25.1 39.2 24.9 27.1 12.1 23.8 15.1 32.8 24.6 12.7 24.6 12.7 29.1 32.8 29.1 23.7 38.8 27 41.8 39.5 28.5 39.5 28.5 41.1 26.8"/>
      </svg>
    </div>
  );
}